export const pathologicalAnatomyConst = {
  path: "/single-programs/pathological-anatomy",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ПАТОЛОГИЧЕСКАЯ АНАТОМИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Патологическая анатомия — диагностика, основанная на глубоком понимании структуры жизни и болезни</h2>
      <p>
        Патологическая анатомия — это основа клинической диагностики. Специалисты этой области исследуют морфологические изменения в
        органах, тканях и клетках, вызванные болезнями. Именно патологоанатом устанавливает окончательный диагноз в сомнительных и сложных
        случаях, а также подтверждает или уточняет диагноз, поставленный при жизни пациента.
      </p>
      <p>
        Эта профессия находится в самом центре медицинского знания, соединяя фундаментальные науки с клинической практикой, биопсией,
        гистологией и вскрытием. Именно здесь формируется истинное понимание болезни.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Патологоанатом в клинике или лаборатории</li>
        <li>Морфолог-исследователь</li>
        <li>Гистолог или цитолог</li>
        <li>Преподаватель морфологических дисциплин</li>
        <li>Эксперт по диагностике в онкологических центрах</li>
        <li>Консультант по результатам биопсий и гистологии в международных лабораториях</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €105,000 в год,</strong> в зависимости от страны, учреждения и специализации.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Программа, соответствующая европейским и международным стандартам</li>
        <li>Возможность очного или дистанционного обучения</li>
        <li>Обучение в виртуальных и реальных гистологических лабораториях</li>
        <li>Прямой контакт с клиническими случаями и образцами</li>
        <li>Преподаватели с клиническим и научным опытом</li>
      </ul>
      <p>
        <strong>
          Патологическая анатомия — это не просто профессия, это наука, раскрывающая суть болезни. Без патоморфолога невозможна точная
          медицина.
        </strong>
      </p>
      <h2>Как поступить?</h2>
      <p>
        Оставьте заявку — приёмная комиссия с радостью подскажет, как выбрать направление, собрать необходимые документы и начать обучение.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Патологическая анатомия — диагностика, основанная на глубоком понимании структуры жизни и болезни
    Патологическая анатомия — это основа клинической диагностики. Специалисты этой области исследуют морфологические изменения в органах, тканях и клетках, вызванные болезнями. Именно патологоанатом устанавливает окончательный диагноз в сомнительных и сложных случаях, а также подтверждает или уточняет диагноз, поставленный при жизни пациента.
    Эта профессия находится в самом центре медицинского знания, соединяя фундаментальные науки с клинической практикой, биопсией, гистологией и вскрытием. Именно здесь формируется истинное понимание болезни.
    Кем можно работать после окончания?
    • Патологоанатом в клинике или лаборатории
    • Морфолог-исследователь
    • Гистолог или цитолог
    • Преподаватель морфологических дисциплин
    • Эксперт по диагностике в онкологических центрах
    • Консультант по результатам биопсий и гистологии в международных лабораториях
    Средний доход в Европе:
    от €60,000 до €105,000 в год, в зависимости от страны, учреждения и специализации.
    Почему выбирают нас? 
    • Программа, соответствующая европейским и международным стандартам
    • Возможность очного или дистанционного обучения
    • Обучение в виртуальных и реальных гистологических лабораториях
    • Прямой контакт с клиническими случаями и образцами
    • Индивидуальное сопровождение студентов
    • Преподаватели с клиническим и научным опытом
    Патологическая анатомия — это не просто профессия, это наука, раскрывающая суть болезни. Без патоморфолога невозможна точная медицина.

    Как поступить?
    Оставьте заявку — приёмная комиссия с радостью подскажет, как выбрать направление, собрать необходимые документы и начать обучение.
  `,
};
